export const findColorByValue = (value: number, breaks: number[], colors: string[]): string => {
  for (let i = breaks.length - 1; i >= 0; i--) {
    if (value >= breaks[i]) {
      return colors[i];
    }
  }
  return colors[0];
};
